import { type ReactNode } from "react";
import { usePreferences } from "../preferences/PreferencesProvider";

// Translation stays beside each message; this single boundary allows later key extraction.
export function I18nProvider({ children }: { children: ReactNode }) { return <>{children}</>; }
export function useI18n() {
  const { locale } = usePreferences();
  return { locale, t: (zh: string, en: string): string => locale === "en" ? en : zh };
}
